export default __webpack_public_path__ + "static/media/fog-low.965eab52.png";